import { Content } from '@prismicio/client';
import {
  TitleMultiRowCardsButtonProps,
  ITitleMultiRowCardsButton,
  IItem,
} from './types';
import { FilledLinkToWebField } from '@prismicio/client';

export const mapTitleMultiRowCardsButton = ({
  prismicContent,
}: {
  prismicContent: TitleMultiRowCardsButtonProps['slice'];
}): ITitleMultiRowCardsButton => {
  const items: IItem[] = prismicContent.items.map(
    (item: Content.TitleMultiRowCardsButtonSliceDefaultItem) => {
      const {
        image: { url: image, alt },
      } = item;

      return {
        ...item,
        image: image as string,
        alt: alt as string,
      };
    },
  );
  const {
    background_image: { url: backgroundImage },
    button_label: buttonLabel,
    internal_link: internalLink,
    external_link: externalLink,
  } = prismicContent.primary;

  const titleMultiRowCardsButton: ITitleMultiRowCardsButton = {
    ...prismicContent.primary,
    backgroundImage: backgroundImage as string,
    buttonLabel: buttonLabel as string,
    link: internalLink || (externalLink as FilledLinkToWebField)!.url,
    items,
  };

  return titleMultiRowCardsButton;
};
